import React from 'react';
import moment from 'moment';
import {
  ITypeIcon1,
  ITypeIcon2,
  ITypeIcon3,
  ITypeIcon4,
} from '../../../resource/icons';
import { typeIds } from '../constants/common';
import { createModalState } from './createModalState';
import { ReactComponent as AdvertisementIcon } from '../../../resource/AdvertisementIcon.svg';

const getInfoTypeIcon = (type, size) => {
  switch (type) {
    case typeIds.debt: {
      return <ITypeIcon1 style={{ height: size, verticalAlign: 'middle' }} />;
    }
    case typeIds.info: {
      return <ITypeIcon2 style={{ height: size, verticalAlign: 'middle' }} />;
    }
    case typeIds.shutdown: {
      return <ITypeIcon3 style={{ height: size, verticalAlign: 'middle' }} />;
    }
    case typeIds.congratulation: {
      return <ITypeIcon4 style={{ height: size, verticalAlign: 'middle' }} />;
    }
    case typeIds.advertisement: {
      return (
        <AdvertisementIcon
          width={size}
          height={size}
          style={{ color: '#0995ED' }}
        />
      );
    }
    default:
      return <div></div>;
  }
};

const formatDate = (date) => moment(date).format('DD.MM.YY HH:mm');

export { createModalState, formatDate, getInfoTypeIcon };
